import React from "react";
import Header from "./Header";
import Sidebar from "./sidebar";
import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { useTheme } from "../ThemeContext.js";
import Chatbot from "./common/Chatbot/Chatbot";
import { TimeLogSavedProvider } from "./utilisation/TimeLogSavedProvider";

const DashboardLayout = () => {
  const { isDarkMode } = useTheme();
  const location = useLocation();

  // List of paths where Header and Sidebar should be hidden
  const noHeaderSidebarPaths = [
    "/subTaskList/", // path with dynamic part
    "/taskdetail",
    "/IssueDetail",
    "/MilestoneDetail",
    "/portalUsersDetail",
    // add more paths as needed
  ];

  // Check if the current path includes any path in the noHeaderSidebarPaths array
  const hideHeaderSidebar = noHeaderSidebarPaths.some((path) =>
    location.pathname.includes(path)
  );

  return (
    <TimeLogSavedProvider>
      <Box sx={{ display: "flex", height: "100vh", overflow: "auto" }}>
        {/* {!hideHeaderSidebar && <Sidebar />} */}
        <Sidebar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: "100vh", // Ensure it matches the sidebar
            overflowY: "auto",
            backgroundColor: isDarkMode ? "#1e1e1e" : "#F4FDFC",
            color: isDarkMode ? "white" : "black",
          }}
          // className=" overflow-hidden"
        >
          {!hideHeaderSidebar && <Header />}
          <div className=" mx-2 ">
            <Outlet /> {/* Nested routes will render here */}
          </div>
        </Box>
      </Box>
      <Chatbot />
    </TimeLogSavedProvider>
  );
};

export default DashboardLayout;
